import React from "react";

import { List } from "affinityUI/data/list";
import { useAuth } from "lib/auth";
import { PatientsListEntry } from "types/patient";

import { PatientCard } from "./patientCard";
import { ResultCard } from "./resultCard";

const isPatientListEntry = (element: PatientsListEntry | null | undefined): element is PatientsListEntry =>
  element !== null && element !== undefined;

export const PatientsView: React.FC<{
  normalRanges?: Maybe<NormalRanges>;
  neutrophilThreshold?: Maybe<number>;
  patients?: Array<PatientsListEntry | null | undefined> | null | undefined;
}> = ({ normalRanges, neutrophilThreshold, patients }) => {
  const [{ isPermitted }] = useAuth();
  const resultsPermitted = isPermitted(["view_resultdata"]);

  return (
    <>
      {patients ? (
        <List>
          {patients
            .filter(isPatientListEntry)
            .map((patient) =>
              resultsPermitted ? (
                <ResultCard
                  key={patient.id}
                  patient={patient}
                  neutrophilThreshold={neutrophilThreshold}
                  normalRanges={normalRanges}
                />
              ) : (
                <PatientCard key={patient.id} patient={patient} />
              )
            )}
        </List>
      ) : (
        <p>No patients available</p>
      )}
    </>
  );
};
